import { render, staticRenderFns } from "./PcPickDetailDialog.vue?vue&type=template&id=305c510a&scoped=true&"
import script from "./PcPickDetailDialog.vue?vue&type=script&lang=js&"
export * from "./PcPickDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./PcPickDetailDialog.vue?vue&type=style&index=0&id=305c510a&scoped=true&lang=css&"
import style1 from "./PcPickDetailDialog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305c510a",
  null
  
)

export default component.exports